export default "__VITE_ASSET__CGF12t3w__"